'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import SplitType from 'split-type';
import styles from '../styles/Loader.module.css';

const Loader = () => {
  const loaderRef = useRef(null);
  const loaderCopy1Ref = useRef(null);
  const loaderCopy2Ref = useRef(null);
  const loaderCopy3Ref = useRef(null);
  const progressBarRef = useRef(null);

  useEffect(() => {
    // Get container elements
    const container = document.querySelector('.container');
    const loader = loaderRef.current;
    const loaderCopy1 = loaderCopy1Ref.current;
    const loaderCopy2 = loaderCopy2Ref.current;
    const loaderCopy3 = loaderCopy3Ref.current;
    const progressBar = progressBarRef.current;

    if (!container || !loader || !loaderCopy1 || !loaderCopy2 || !loaderCopy3 || !progressBar) return;

    // Set initial container style
    container.style.height = "100vh";
    container.style.overflow = "hidden";

    // Initialize SplitType for each loader text
    const loaders = [loaderCopy1, loaderCopy2, loaderCopy3];
    const splitTexts = loaders.map(loader => new SplitType(loader, { types: "words" }));
    
    // Set initial opacity
    gsap.to(loaders, { opacity: 1, duration: 0.1 });

    // Animation for each loader text
    setTimeout(() => {
      loaders.forEach((loaderEl, index) => {
        const words = splitTexts[index].words;
        gsap.to(words, {
          opacity: 1,
          duration: 1,
          stagger: 0.15,
          delay: index === 2 ? index * 2.75 : index * 2.5,
          onComplete: () => {
            gsap.to(words, {
              opacity: 0,
              duration: 1,
              stagger: 0.15,
            });
          },
        });
      });
    }, 1000);

    // Progress bar animation
    gsap.to(progressBar, {
      width: "100%",
      duration: 8,
      delay: 0.5,
      onComplete: () => {
        gsap.to(progressBar, {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          duration: 1,
          ease: "power2.inOut",
          onComplete: () => {
            gsap.to([progressBar, loader], {
              clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
              duration: 1,
              ease: "power2.inOut",
              onStart: () => {
                container.style.height = "100%";
                container.style.overflow = "scroll";
              },
            });
          },
        });
      },
    });
  }, []);

  return (
    <div className={styles.loader} ref={loaderRef}>
      <div className="loader-copy">
        <p ref={loaderCopy1Ref} id="loader-copy-1" className={styles.loaderCopy1}>Loading in progress</p>
        <p ref={loaderCopy2Ref} id="loader-copy-2" className={styles.loaderCopy2}>A few seconds please</p>
        <p ref={loaderCopy3Ref} id="loader-copy-3" className={styles.loaderCopy3}>Almost done</p>
      </div>
      <div ref={progressBarRef} className={styles.progressBar}></div>
    </div>
  );
};

export default Loader; 